import React, {useEffect, useState} from 'react'
import {ModalBody, ModalFooter, ModalHeader} from '_core/components/Modal'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '_metronic/helpers'
import SearchProducts from './SearchBar'
import searchProductsService from 'app/services/SearchProductsService/SearchProductsService'
import ProductList from './product/ProductList'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

interface Props {
  onClose: () => void
  searchedText: string
  onAdd: (value: any) => void
}

const pageSize = 8

export const SearchProductDialog: React.FC<Props> = ({onClose, searchedText, onAdd}) => {
  const [products, setProducts] = useState<any[]>([])
  const [searchText, setSearchText] = useState(searchedText)
  const [isFetching, setIsFetching] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const selectedVariants = useSelector<RootState, any[]>(
    ({orders}) => orders.product.selectedVariants
  )

  const fetchProducts = async (searchText: string) => {
    try {
      setIsFetching(true)
      const data = await searchProductsService.searchProducts(searchText)
      setProducts(data)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    fetchProducts(searchedText)
  }, [searchedText])

  const handleSearch = async (value: any) => {
    setSearchText(value)
    fetchProducts(value)
  }

  const handlePageChange = (currentPage: any) => {
    setCurrentPage(currentPage)
  }

  const lastIndex = pageSize * currentPage
  const firstIndex = lastIndex - pageSize

  const handleAdd = () => {
    onAdd(selectedVariants)
    setSearchText('')
  }

  return (
    <div>
      <Modal centered backdropClassName='opacity-75' onHide={onClose} show={true} size='lg'>
        <ModalHeader
          className='modal-header d-flex py-5'
          title={
            <>
              <KTSVG className='svg-icon-3hx me-2' path='/media/icons/corksy/product_tag.svg' />
              <span>Add Products</span>
            </>
          }
          toolbar={{
            onClick: onClose,
            className: 'svg-icon-2qx svg-icon-primary',
          }}
        />
        <div className='pt-4 mx-7 mb-2'>
          <SearchProducts onHandleSearch={handleSearch} searchText={searchText} isFocus={true} />
        </div>
        <ModalBody
          className='border border-bottom-0'
          isFetching={isFetching}
          isOuterPaging
          pagination={{
            pageSize,
            currentPage,
            onPageChange: handlePageChange,
            totalCount: products.length,
          }}
        >
          <ProductList products={products.slice(firstIndex, lastIndex)} />
        </ModalBody>
        <ModalFooter
          close={{
            id: 'btnProductClose',
            text: 'Cancel',
            onClick: onClose,
            className: 'btn explore-btn-outline me-3',
          }}
        >
          <button
            id='btnProductAdd'
            className='btn btn-primary-active'
            onClick={handleAdd}
            disabled={selectedVariants.length === 0}
          >
            Add
          </button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default SearchProductDialog
